import { z } from 'zod';

export const tinyMCEDynamicOptionsSchema = z.object({
    cache_suffix: z.string(),
    toolbar: z.string(),
    language: z.string(),
    content_css: z.string(),
    quickbars_selection_toolbar: z.string(),
    sandbox_iframes: z.optional(z.boolean()),
    sandbox_iframes_exclusions: z.optional(z.array(z.string())),
});
export type TinyMCEDynamicOptions = z.infer<typeof tinyMCEDynamicOptionsSchema>;

export const tinyMCECommonOptionsSchema = tinyMCEDynamicOptionsSchema.extend({
    plugins: z.array(z.string()),
    text_patterns: z.array(
        z.object({
            start: z.string(),
            end: z.string().optional(),
            format: z.string().optional(),
            cmd: z.string().optional(),
        }),
    ),
    height: z.number(),
    menubar: z.boolean(),
    branding: z.boolean(),
    skin: z.string(),
    convert_urls: z.boolean(),
    invalid_elements: z.string(),
    extended_valid_elements: z.string(),
    custom_elements: z.string(),
    inline_boundaries_selector: z.string(),
    toolbar_mode: z.union([z.literal('floating'), z.literal('sliding'), z.literal('scrolling'), z.literal('wrap')]),
    promotion: z.boolean(),
    font_size_formats: z.string(),
    contextmenu: z.union([z.string(), z.literal(false)]),
    paste_data_images: z.boolean(),
    browser_spellcheck: z.boolean(),
    quickbars_insert_toolbar: z.boolean(),
    license_key: z.literal('gpl'),
});
export type TinyMCECommonOptions = z.infer<typeof tinyMCECommonOptionsSchema>;

export const tinymceExtendedOptionsSchema = z.object({
    commentsToolbar: z.string(),
});
export type TinyMCEExtendedOptions = z.infer<typeof tinymceExtendedOptionsSchema>;
